"use strict";

exports.__esModule = true;
exports.default = void 0;
var _views = require("./views");
var _default = exports.default = {
  account: {
    path: 'account',
    title: 'Account',
    private: true,
    component: _views.Account
  },
  signIn: {
    path: 'sign-in',
    title: 'Log In',
    component: _views.SignIn
  },
  signUp: {
    path: 'sign-up',
    title: 'Sign Up',
    component: _views.SignUp
  },
  forgotPassword: {
    path: 'forgot-password',
    title: 'Forgot Password',
    component: _views.RequestCode
  },
  newPassword: {
    path: 'new-password',
    title: 'Set New Password',
    component: _views.ResetPassword
  },
  postSignUp: {
    path: 'post-sign-up',
    title: 'Post Sign Up',
    component: _views.PostSignUp
  }
};
module.exports = exports.default;